<template>
  <div id="rounded-button-wrapper" ref="rounded-button-wrapper">
    <button
      class="rounded-button"
      @click="roundedButtonClicked"
      ref="rounded-button"
      :disabled="disabled || loading"
    >
      <slot v-if="!loading"></slot>
      <template v-else>
        <loader-ring :size="'20px'" />
      </template>
    </button>
  </div>
</template>

<script>
import createRipple from "@/assets/js/rippleEffect.js";
export default {
  name: "RoundedButton",
  props: {
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    width: {
      type: String,
      required: false,
      default: "100%"
    },
    height: {
      type: String,
      required: false,
      default: "35px"
    },
    buttonType: {
      type: String,
      required: false,
      default: "primary"
    },
    isOutline: {
      type: Boolean,
      required: false,
      default: false
    },
    position: {
      type: String,
      required: false,
      default: "left"
    }
  },
  mounted() {
    this.$refs["rounded-button-wrapper"].style.height = this.height;
    this.$refs["rounded-button-wrapper"].style.width = this.width;
    this.$refs["rounded-button-wrapper"].classList.add(this.position);
    if (this.isOutline) {
      this.$refs["rounded-button"].classList.add("outlined");
    }
    this.changeButtonDisabledStyle();
  },
  methods: {
    roundedButtonClicked(event) {
      createRipple(event);
      this.$emit("click");
    },
    changeButtonDisabledStyle() {
      if (!(this.disabled || this.loading)) {
        this.$refs["rounded-button"].classList.remove("disabled");
        this.$refs["rounded-button"].classList.add(this.buttonType);
      } else {
        this.$refs["rounded-button"].classList.remove(this.buttonType);
        this.$refs["rounded-button"].classList.add("disabled");
      }
    }
  },
  watch: {
    isOutline() {
      if (this.isOutline) {
        this.$refs["rounded-button"].classList.add("outlined");
      } else {
        this.$refs["rounded-button"].classList.remove("outlined");
      }
    },
    disabled() {
      this.changeButtonDisabledStyle();
    },
    loading() {
      this.changeButtonDisabledStyle();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";
#rounded-button-wrapper {
  .rounded-button {
    cursor: pointer;
    width: 100%;
    height: 100%;
    outline: none;
    border-radius: 15px;
    font-size: 14px;
    color: white;
    position: relative;
    overflow: hidden;
    transition: all 800ms;
    box-shadow: $input-shadow;
    padding-left: 15px;
    padding-right: 15px;
    &.outlined {
      background: white !important;
      color: unset !important;
      // &:hover {
      //   background: rgba($color-danger, 0.05) !important;
      // }
    }
  }
  .primary {
    border: 1px solid $color-primary;
    background: linear-gradient(
      to top right,
      $color-primary,
      $color-light-primary
    );
    &:hover {
      background: linear-gradient(to top right, $color-primary, $color-primary);
    }
  }
  .danger {
    border: 1px solid $color-danger;
    background: $color-danger;
    &:hover {
      background: $color-danger;
    }
  }
  .disabled {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid $color-disabled;
    background: $color-disabled;
    box-shadow: none !important;
  }
}
.center {
  margin-left: auto;
  margin-right: auto;
}
.right {
  margin-left: auto;
  margin-right: 0;
}
.left {
  margin-left: 0;
  margin-right: auto;
}
</style>
